import React from 'react';
import { Gift } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Bonos() {
  const bonos = [{
    title: 'Checklist técnica fundamental',
    price: '$3.990'
  }, {
    title: 'Hoja de puntaje y notas tácticas por partido',
    price: '$2.490'
  }, {
    title: 'Diagrama de posicionamiento en dobles',
    price: '$2.990'
  }, {
    title: 'Tabla de estadísticas personales',
    price: '$1.990'
  }, {
    title: 'Glosario del pádel: 50 términos esenciales',
    price: '$3.490'
  }, {
    title: 'Rutina de calentamiento y prevención de lesiones',
    price: '$4.990'
  }];
  return <section className="py-14 bg-court-gradient relative border-t border-white/5" data-id="element-17">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-18">
        <FadeIn data-id="element-19">
          <div className="flex justify-center mb-4" data-id="element-20">
            <div className="bg-neon/20 p-3 rounded-full" data-id="element-21">
              <Gift className="w-8 h-8 text-neon" data-id="element-22" />
            </div>
          </div>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-2 uppercase" data-id="element-23">
            Además recibís estos bonos exclusivos
          </h2>
          <p className="text-center mb-10" data-id="element-24">
            <span className="inline-block bg-neon text-black font-display font-bold text-sm uppercase tracking-wide px-4 py-1 rounded-full" data-id="element-25">
              Gratis por hoy
            </span>
          </p>
        </FadeIn>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6" data-id="element-26">
          {bonos.map((bono, idx) => <FadeIn key={idx} delay={idx * 0.08} data-id="element-27">
              <div className="relative group" data-id="element-28">
                {/* Gratis Tag */}
                <div className="absolute -top-2 -right-2 bg-red-500 text-white font-bold text-[10px] py-0.5 px-2 rounded-full transform rotate-12 z-20 shadow-lg" data-id="element-29">
                  GRATIS
                </div>

                {/* Mini Ebook Card */}
                <div className="bg-gradient-to-br from-padel-blue to-padel-dark border border-white/10 rounded-lg p-5 h-40 flex flex-col justify-center items-center text-center shadow-xl relative overflow-hidden transform transition-transform group-hover:-translate-y-1 group-hover:border-neon/50" data-id="element-30">
                  <div className="absolute top-0 left-0 w-1.5 h-full bg-neon/80" data-id="element-31"></div>
                  <div className="text-neon font-display font-bold text-xs mb-2 tracking-widest opacity-80" data-id="element-32">
                    BONO {idx + 1}
                  </div>
                  <h3 className="font-bold text-sm md:text-base leading-snug mb-2" data-id="element-33">
                    {bono.title}
                  </h3>
                  <p className="text-gray-400 text-xs" data-id="element-34">
                    Valor <span className="line-through" data-id="element-35">{bono.price}</span> ·{' '}
                    <span className="text-neon font-bold" data-id="element-36">$0</span>
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}